/**
 * Created by Simone.Sacchi on 18/01/2017.
 */

"use strict";

let _default;
/**
 * Allow to include this file also in node.js context: used to run the tests.
 * This had to be done when we removed jest for running tests, due to security issues.
 *
 * @author Simone Sacchi
 * @version 2025/10/29
 */
if (typeof window !== 'undefined') {
    _default = window.sessionStorage;
}

const ClientStorageSingleton = (function () {

    // ==========================================
    // PRIVATE
    // ==========================================
    let _storage = {};

    // ==========================================
    // PUBLIC
    // ==========================================
    return {

        setItem (key, value) {
            _storage[key] = value;
        },
        getItem (key) {
            if (_storage.hasOwnProperty(key)) {
                return _storage[key];
            }
        },
        removeItem (key) {
            if (_storage.hasOwnProperty(key)) {
                delete _storage[key];
            }
        },
        clear () {
            _storage = {};
        }

    };

}());

module.exports = _default ? _default : ClientStorageSingleton;
